export const colors = {
    primary: '#019688',
    dark: '#122C34',
    black: '#000000',
    white: '#ffffff',
    danger: '#FF0000',
    success: '#66bb6a',
    lightTransparent: "rgba(255, 255, 255, 0.65)",
    darkTransparent: "rgba(0, 0, 0, 0.5)",
    lightGray: "#E6E6E6",
    warning: '#FF8404',
    darkgrey: 'rgb(123, 123, 123)',
    dasbordtextColor: "#484848",
    pending: "#FF9E00",
};